import React from "react";
import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { ThemeProvider } from "next-themes";
import { reducerType } from "../redux/reducers";
import { useRumPageView } from "./hooks/useRumPageView";
import IDELayout from "./components/IDELayout";
import HomePage from "./components/HomePage";
import ProjectsPage from "./components/ProjectsPage";
import ArchitectureComposerPage from "./components/ArchitectureComposerPage";
import { AuthenticationWrapper } from "./components/AuthenticationWrapper";
import TacoCognitoErrorHandler from "./components/auth/TacoCognitoErrorHandler";
import WebSocketProvider from "./contexts/Websocket/WebSocketProvider";
import "./App.css";
import { DataProvider } from "./contexts/DataContext";

function App() {
  const isSignedIn =
    useSelector((state: reducerType) => state.Auth.signedIn) ?? false;

  // Track page views on route changes
  useRumPageView();

  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
      <TacoCognitoErrorHandler>
        <AuthenticationWrapper isSignedIn={isSignedIn}>
          <WebSocketProvider>
            <DataProvider>
              <AppContent />
            </DataProvider>
          </WebSocketProvider>
        </AuthenticationWrapper>
      </TacoCognitoErrorHandler>
    </ThemeProvider>
  );
}

function AppContent() {
  return (
    <div className="App h-screen bg-background">
      <div className="h-full">
        <Routes>
          {/* Homepage without Layout */}
          <Route path="/" element={<HomePage />} />

          {/* Projects page without Layout */}
          <Route path="/projects" element={<ProjectsPage />} />

          {/* IDE Layout for project pages */}
          <Route path="/project/:projectId" element={<IDELayout />}>
            <Route index element={<ArchitectureComposerPage />} />
          </Route>
        </Routes>
      </div>
    </div>
  );
}

export default App;
